import React from 'react';
import { motion } from 'framer-motion';
import { Headphones, Zap, Smartphone } from 'lucide-react';
import { CheckCircle2 } from 'lucide-react';
const features = [{
  icon: Headphones,
  text: 'One earbud. Eyes open. Baby in arms. Fully compatible.'
}, {
  icon: Zap,
  text: 'Each audio targets one specific moment — not "postpartum wellness" in general.'
}, {
  icon: Smartphone,
  text: 'No app. No subscription. No login. Yours forever.'
}, {
  icon: CheckCircle2,
  text: 'Instant access. Start with Audio 2 if today was hard.'
}];
export function HowItWorksSection() {
  return <section className="py-14 px-6 bg-gradient-to-b from-[#F8F5F0] to-[#EFEBE4] relative overflow-hidden" data-id="element-120">
      {/* Decorative background circle */}
      <div className="absolute top-0 right-0 -translate-y-1/2 translate-x-1/3 w-96 h-96 bg-copper/5 rounded-full blur-[80px] pointer-events-none" data-id="element-121" />

      <div className="max-w-md mx-auto relative z-10" data-id="element-122">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-123">
          <span className="text-copper opacity-60 text-sm tracking-[0.2em] uppercase font-semibold mb-4 block" data-id="element-124">
            ✦ What Makes This Different ✦
          </span>
          <h2 className="font-playfair text-charcoal text-4xl md:text-5xl font-medium" data-id="element-125">
            Not a course you{' '}
            <span className="italic text-copper" data-id="element-126">have to finish</span>
          </h2>
          <p className="font-inter text-charcoal opacity-70 mt-4" data-id="element-127">
            Not a 20-minute meditation you'll never start. Not advice that
            assumes you have two free hands.
          </p>
        </motion.div>

        <div className="relative" data-id="element-128">
          {/* Vertical connecting line */}
          <div className="absolute left-[27px] top-8 bottom-8 w-[1px] bg-gradient-to-b from-copper/40 via-copper/20 to-transparent" data-id="element-129" />

          <div className="flex flex-col gap-12" data-id="element-130">
            {features.map((feature, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.6,
            delay: index * 0.2
          }} className="flex items-start gap-8 relative" data-id="element-131">
                {/* Icon Container */}
                <div className="relative shrink-0 w-14 h-14 rounded-full bg-white shadow-[0_4px_20px_rgba(201,166,107,0.15)] border border-copper/20 flex items-center justify-center z-10" data-id="element-132">
                  <feature.icon className="w-6 h-6 text-copper" strokeWidth={1.5} data-id="element-133" />
                </div>

                {/* Text */}
                <div className="pt-3" data-id="element-134">
                  <p className="font-inter text-charcoal text-lg md:text-xl leading-relaxed opacity-90 font-light" data-id="element-135">
                    {feature.text}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}